import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, CustomEase, DrawSVGPlugin, ScrollSmoother);

// create the scrollSmoother before your scrollTriggers
ScrollSmoother.create({
  smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
  effects: true, // looks for data-speed and data-lag attributes on elements
  smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  normalizeScroll: true
});

gsap.registerPlugin(ScrollTrigger);

export default function introSection() {
  const mm = gsap.matchMedia();

  gsap.set('#liane1', {
    drawSVG: 0
  });

  gsap.set('body', { backgroundColor: '#47B27A' });

  gsap.set(
    '#lianeklein1, #lianeklein3, #wiggle_leaf, #lianeklein1_mobile, #lianeklein3_mobile, #wiggle_leaf_mobile',
    {
      scaleY: 0,
      transformOrigin: 'top center'
    }
  );

  gsap
    .timeline()
    .to('#abw_scroll_down', { opacity: 1, duration: 2 }, 0.25)
    .to('#abw_scroll_down', {
      yPercent: -10,
      yoyoEase: 'power2.inOut',
      yoyo: true,
      repeat: -1,
      duration: 1
    });

  // Desktop
  mm.add('(min-width: 960px)', () => {
    gsap
      .timeline(
        {
          defaults: { ease: 'elastic.out(1, 0.3)' },
          scrollTrigger: {
            trigger: '#abw_section_1',
            pin: false,
            scrub: false,
            start: 'top top',
            end: 'bottom bottom',
            toggleActions: 'play none none reverse'
          }
        },
        0
      )
      .to('#lianeklein1', { scaleY: 1, duration: 2 }, 0.5)
      .to('#wiggle_leaf', { scaleY: 1, duration: 2.25 }, 1)
      .to('#lianeklein3', { scaleY: 1, duration: 2 }, 0.5)
      .to('#abw_scroll_down', { opacity: 0, duration: 0.5, ease: 'none' }, 0.5);

    gsap.set('#wiggle_leaf', {
      rotate: -10
    });

    gsap
      .timeline(
        {
          defaults: { ease: 'power1.inOut', duration: 2 },

          scrollTrigger: {
            trigger: '#abw_section_1',
            start: 'top top'
          }
        },
        0
      )
      .to('#wiggle_leaf', {
        rotate: 10,
        yoyoEase: 'power2.inOut',
        yoyo: true,
        repeat: -1
      });

    gsap.set('#tree1_left, #tree2_left, #tree3_left', {
      transformOrigin: 'center left'
    });

    gsap.set('#tree1_right, #tree2_right, #tree3_right', {
      transformOrigin: 'center right'
    });

    gsap.set('#tree3_right', {
      yPercent: 10
    });

    ScrollTrigger.create({
      trigger: '#abw_section_1',
      pin: '#abw_section_1',
      start: 'top top',
      end: '+=150%',
      scrub: true,
      // onRefresh: (self) => self.progress && self.animation.progress(1),
      anticipatePin: 0.5
    });

    gsap
      .timeline(
        {
          defaults: { duration: 1, ease: 'none' },
          scrollTrigger: {
            trigger: '#abw_section_1',
            pin: false,
            scrub: true,
            start: 'top top',
            end: '+=200%'
          }
        },
        0
      )
      .to(
        '#tree3_left',
        {
          scale: 0.5,
          rotate: -20,
          y: '10%',
          duration: 2
        },
        0
      )
      .to(
        '#tree2_left',
        {
          scale: 0.5,
          rotate: -28,
          yPercent: '-6',
          duration: 2
        },
        0.25
      )
      .to(
        '#tree1_left',
        {
          scale: 0.5,
          yPercent: '-3',
          duration: 2
        },
        0.5
      )
      .to(
        '#tree3_right',
        {
          scale: 0.5,
          rotate: 20,
          yPercent: 6,
          duration: 2
        },
        0
      )
      .to(
        '#tree2_right',
        {
          scale: 0.5,
          rotate: 28,
          duration: 2
        },
        0.25
      )
      .to(
        '#tree1_right',
        {
          scale: 0.657,
          duration: 2
        },
        0.5
      )

      .fromTo(
        'body',
        { backgroundColor: '#47B27A' },
        { backgroundColor: '#13735F' },
        0
      )
      .fromTo(
        '#liane1',
        { drawSVG: '100% 100%' },
        { drawSVG: '0% 100%', duration: 6 },
        1
      )
      .fromTo(
        '#watchface, #watchface_mobile',
        {
          fill: '#13735F'
        },
        { fill: '#E6CE00' },
        6
      )
      .fromTo(
        'body',
        {
          backgroundColor: '#13735F'
        },
        { backgroundColor: '#E6CE00' },
        6
      );
  });

  // Mobile
  mm.add('(max-width: 959px)', () => {
    gsap
      .timeline(
        {
          defaults: { ease: 'elastic.out(1, 0.3)' },
          scrollTrigger: {
            trigger: '#abw_section_1',
            pin: false,
            scrub: false,
            start: 'top 10%',
            end: 'bottom bottom'
          }
        },
        0
      )
      .to('#lianeklein1_mobile', { scaleY: 1, duration: 2 }, 0)
      .to('#wiggle_leaf_mobile', { scaleY: 1, duration: 2.25 }, 0)
      .to('#lianeklein3_mobile', { scaleY: 1, duration: 2 }, 0)
      .to('#abw_scroll_down', { opacity: 0, duration: 0.5, ease: 'none' }, 0.1);

    gsap.set('#wiggle_leaf_mobile', {
      rotate: -10
    });

    gsap
      .timeline(
        {
          defaults: { ease: 'power1.inOut', duration: 2 },
          repeat: -1,
          scrollTrigger: {
            trigger: '#abw_section_1',
            start: 'top 10%'
          }
        },
        0
      )
      .to('#wiggle_leaf_mobile', { rotate: 10 })
      .to('#wiggle_leaf_mobile', { rotate: -10 });

    gsap.set('#tree1_left_mobile, #tree2_left_mobile, #tree3_left_mobile', {
      transformOrigin: 'center left'
    });

    gsap.set('#tree1_right_mobile, #tree2_right_mobile, #tree3_right_mobile', {
      transformOrigin: 'center right'
    });

    gsap.set('#tree3_right_mobile', {
      rotate: 5,
      yPercent: -10,
      scale: 0.7
    });

    gsap.set('.aw_btn_download', {
      opacity: 0,
      yPercent: -10
    });

    ScrollTrigger.create({
      trigger: '#abw_section_1',
      pin: '#abw_section_1',
      start: 'top top',
      end: '+=150%',
      scrub: true

      // anticipatePin: 1
    });

    gsap
      .timeline(
        {
          defaults: { duration: 1, ease: 'none' },
          scrollTrigger: {
            trigger: '#abw_section_1',
            pin: false,
            scrub: true,
            start: 'top top',
            end: '+=200%'
          }
        },
        0
      )
      .to(
        '#tree3_left_mobile',
        {
          scale: 0.5,
          rotate: -20,
          xPercent: -1,
          duration: 2
        },
        0
      )
      // .to(
      //   '#tree2_left_mobile',
      //   {
      //     scale: 0.5,
      //     rotate: -28,
      //     xPercent: -10,
      //     duration: 2
      //   },
      //   0.25
      // )
      // .to(
      //   '#tree1_left_mobile',
      //   {
      //     scale: 0.5,
      //     rotate: -34,
      //     xPercent: -45,
      //     duration: 2
      //   },
      //   0.5
      // )
      .to(
        '#tree3_right_mobile',
        {
          scale: 0.5,
          rotate: 20,
          xPercent: 1,
          duration: 2
        },
        0
      )
      // .to(
      //   '#tree2_right_mobile',
      //   {
      //     scale: 0.5,
      //     rotate: 28,
      //     xPercent: 10,
      //     duration: 2
      //   },
      //   0.25
      // )
      // .to(
      //   '#tree1_right_mobile',
      //   {
      //     scale: 0.5,
      //     rotate: 34,
      //     xPercent: 45,
      //     duration: 2
      //   },
      //   0.5
      // )
      .to(
        'body',
        { backgroundColor: '#47B27A' },
        { backgroundColor: '#13735F', duration: 2 },
        0
      )
      .to('.aw_btn_download', { opacity: 1, yPercent: 0 }, 0.5)
      .fromTo(
        '#liane1_mobile',
        { drawSVG: '100% 100%' },
        { drawSVG: '0% 100%', duration: 2 },
        1
      )
      .fromTo(
        '#watchface, #watchface_mobile',
        {
          fill: '#13735F'
        },
        { fill: '#E6CE00' },
        2
      )
      .fromTo(
        'body',
        {
          backgroundColor: '#13735F'
        },
        { backgroundColor: '#E6CE00' },
        2
      );
  });
}
